import React from 'react';
import AdSpace from './AdSpace';

const PageLayout = ({ children }) => {
  return (
    <div style={styles.layoutContainer}>
      <div style={styles.mainContent}>
        {children}
      </div>
      <aside className="ads-container">
        <AdSpace />
      </aside>
    </div>
  );
};

const styles = {
  layoutContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '30px',
    padding: '20px',
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  mainContent: {
    minWidth: '0', // Prevents content from overflowing
  },
  sidebar: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  '@media (maxWidth: 1024px)': {
    layoutContainer: {
      gridTemplateColumns: '1fr',
      gap: '20px',
    },
    sidebar: {
      width: '100%',
      maxWidth: '600px',
      margin: '0 auto',
    },
  },
};

export default PageLayout;
